<template>
  <v-container
    fluid
    class="pa-0 pr-4 daytime-advice-images"
  >
    <v-row>
      <v-col
        cols="12"
        sm="12"
        md="12"
        class="pt-0"
      >
        <v-container
          fluid
          class="pb-0"
        >
          <div class="daytime-advice-images-list">
            <div
              v-for="madia in daytimeAdviceImages"
              :key="madia.id"
              class="daytime-advice-image-item"
            >
              <v-card
                :flat="true"
                tile
              >
                <img
                  v-if="madia.extension == 'jpg'"
                  :src="madia.url"
                  class="daytime-advice-thumb"
                  oncontextmenu="return false;"
                  onselectstart="return false;"
                  onmousedown="return false;"
                  @click="showMedia(madia)"
                >
                <video
                  v-if="madia.extension == 'mp4'"
                  :src="madia.url"
                  class="daytime-advice-thumb"
                  controlsList="nodownload"
                  oncontextmenu="return false;"
                  @click="showMedia(madia)"
                />
                <a
                  v-if="madia.extension == 'pdf'"
                  :href="`/api/v1/daytime_advice_sheet_images/${madia.id}/download`"
                  target="_blank"
                  class="daytime-advice-pdf-link"
                >
                  <v-icon
                    size="48px"
                    style="border: 1px solid #CCC"
                  >
                    picture_as_pdf
                  </v-icon>
                </a>
              </v-card>
            </div>
          </div>
        </v-container>
      </v-col>
    </v-row>
    <!-- modal -->
    <media-viewer-dialog
      v-model="mediaViewer.open"
      :src="mediaViewer.src"
      :title="mediaViewer.title"
      :kind="mediaViewer.kind"
      @error="onMediaViewerError"
    />
    <!--// modal -->
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import {
  MEDIA_VIEWER_KINDS,
  MediaViewerDialog,
  createMediaViewerState,
  handleMediaViewerError,
  openMediaViewer,
} from "../../features/media-viewer";

export default {
  name: "DaytimeAdviceImages",
  components: {
    MediaViewerDialog,
  },
  data: () => ({
    mediaViewer: createMediaViewerState(),
  }),
  computed: {
    ...mapGetters([
      "daytimeAdviceImages",
      "daytimeAdviceMediaFile"
    ]),
  },
  watch: {
    "$route" () {
      this.fetchImages();
    }
  },
  created() {
    this.fetchImages();
  },
  methods: {
    showMedia: function(media) {
      this.$store.dispatch("viewDaytimeAdviceMedia", media.id).then(() => {
        const extension = this.daytimeAdviceMediaFile.extension;
        const kind = extension === "mp4" ? MEDIA_VIEWER_KINDS.VIDEO : MEDIA_VIEWER_KINDS.IMAGE;
        openMediaViewer(this.mediaViewer, {
          src: this.daytimeAdviceMediaFile.url,
          title: "",
          kind,
        });
      });
    },
    onMediaViewerError() {
      handleMediaViewerError(this.mediaViewer);
    },
    fetchImages: function(){
      this.$store.dispatch("fetchDaytimeAdviceImages", {
        id: this.$route.params.id
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.daytime-advice-images-list {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 4px;
}

.daytime-advice-image-item {
  flex: 0 0 auto;
}

.daytime-advice-thumb {
  width: auto;
  height: 48px;
  max-width: none;
  object-fit: contain;
  display: block;
  cursor: pointer;
}

.daytime-advice-pdf-link {
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
